export const otkaz_ugovora_o_radu_izvanredni = {
  templateId: 16,
  category: 1,
  templateTitle: "Odluka o izvanrednom otkazu ugovora o radu radniku uslijed teške povrede iz radnog odnosa",
  templateDescription: `Zbog osobito teške povrede obveze iz radnog odnosa ili neke druge osobito važne činjenice, poslodavac i radnik mogu otkazati ugovor o radu (sklopljen na određeno/neodređeno vrijeme) bez obveze poštivanja propisanog ili ugovorenog otkaznog roka.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Ovaj tekst, kao i dolje navedeni primjer odluke odnose se na situacije davanja izvanrednih otkaza u kojima poslodavac zapošljava manje od dvadeset radnika te kod poslodavca nije donesen pravilnik o radu (obveza poslodavca koji zapošljava 20 i više radnika).</p>
    <p>Poslodavac i radnik imaju opravdani razlog za otkaz ugovora o radu sklopljenog na neodređeno ili određeno vrijeme, <strong>bez obveze poštivanja propisanog ili ugovorenog otkaznog roka</strong> (izvanredni otkaz), ako zbog osobito teške povrede obveze iz radnog odnosa ili neke druge osobito važne činjenice, uz uvažavanje svih okolnosti i interesa obiju ugovornih stranaka, nastavak radnog odnosa nije moguć. </p>
    <p>Zakon o radu ne propisuje osobito teške povrede obveza iz radnog odnosa uslijed povrede kojih poslodavac može dati radniku izvanredni otkaz, nego se iste procjenjuju od slučaja do slučaja. </p>
    <p>Prije izvanrednog otkazivanja uvjetovanog ponašanjem radnika, poslodavac je dužan omogućiti radniku da iznese svoju obranu, osim ako postoje okolnosti zbog kojih nije opravdano očekivati od poslodavca da to učini. </p>
    <p><strong>Ugovor o radu može se izvanredno otkazati samo u roku od petnaest dana od dana saznanja za činjenicu na kojoj se izvanredni otkaz temelji. </strong></p>
    <p>Kao što je gore navedeno, radnik nema pravo na otkazni rok te radni odnos prestaje uručenjem otkaza. </p>
    <p><strong>Otkaz mora biti u pisanom obliku.</strong> </p>
    <p>Poslodavac mora u pisanom obliku <strong>obrazložiti</strong> otkaz. </p>
    <p><strong>Obrazloženje mora sadržavati mjerodavne razloge na kojima se temelji odluka o otkazu.</strong> </p>
    <p>Razlozi otkaza navedeni u obrazloženju moraju biti jasni i nedvojbeni.</p>
    <p>U eventualnom sudskom postupku osporavanja otkaza, postupak se ograničava na razloge navedene u obrazloženju te se novi dokazi i razlozi ne mogu isticati, zbog toga je iznimno bitno da obrazloženje sadrži mjerodavne razloge.</p>
    <p>Sadržaj obrazloženja mora se odnositi na vrstu otkaza koji se daje radniku te isti moraju biti usklađeni, u protivnom je otkaz nezakonit.</p>
    <p><strong>Otkaz se mora dostaviti osobi kojoj se otkazuje.</strong> </p>
    <p>Ako postupak dostave nije uređen kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca ili pravilnikom o radu, na dostavu odluka o otkazu ugovora o radu, primjenjuju se na odgovarajući način odredbe o dostavi iz propisa kojim je uređen parnični postupak. </p>
    <p>Npr. otkaz se može dostaviti preporučenom poštanskom pošiljkom s povratnicom ili osobno na radnom mjestu uz potvrdu primitka, no ukoliko radnik ne želi primiti otkaz, navedene odbijanje se može konstatirati uz potpis dva svjedoka, čim se prema sudskoj praksi smatra da je otkaz valjano dostavljen. Otkaz se može dostaviti i putem javnog bilježnika. </p>
    <p>Zakonom o radu nisu propisani pojedini specifični razlozi otkaza ugovora o radu, nego poslodavac razlog za svaki otkaz utvrđuje od slučaja do slučaju. Dakle, zakon daje samo okvir i propisuje vrste otkaza pretpostavke osnovanosti, a na poslodavcu je da svaki specifični razlog posebno utvrdi i obrazloži. </p>
    <p><strong>Ukoliko je kod poslodavca utemeljeno radničko vijeće odnosno kod poslodavca postoji imenovan sindikalni povjerenik (koji preuzima sva prava i obveze radničkog vijeća propisane Zakonom o radu), poslodavac je dužan savjetovati se (za razliku od suglasnosti, gdje je pozitivno mišljenje preduvjet donošenja odluke) s radničkim vijećem/sindikalnim povjerenikom prije odluke o otkazu. Podrazumijeva se da poslodavac ima navedenu obvezu samo ukoliko je radničko vijeće utemeljeno (ukoliko su radnici formirali radničko vijeće), odnosno ukoliko je sindikat pisano obavijestio poslodavca o imenovanju sindikalnog povjerenika, na način i pod uvjetima propisanim Zakonom o radu. Radničko vijeće/sindikalni povjerenik je u tom smislu dužan u roku od osam dana, a u slučaju izvanrednog otkaza u roku od pet dana, dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu. Ako se radničko vijeće/sindikalni povjerenik ne očituje o namjeravanoj odluci u navedenom roku, smatra se da nema primjedbi i prijedloga. </strong> </p>
    <p><strong>Važno je naglasiti da poslodavac nije vezan očitovanjem radničkog vijeća/sindikata te svoju odluku može donijeti čak iako se navedeni protive istoj, no dužan je savjetovati se, jer je u protivnom odluka o otkazu ništetna (ne proizvodi pravne učinke). </strong> </p>
    <p>Ipak, poslodavac  može samo uz prethodnu suglasnost radničkog vijeća/sindikalnog povjerenika donijeti odluku o:</p>
    <p>1) otkazu članu radničkog vijeća, </p>
    <p>2) otkazu kandidatu za člana radničkog vijeća koji nije izabran, u razdoblju od tri mjeseca nakon utvrđenih konačnih rezultata izbora, </p>
    <p>3) otkazu radniku kod kojeg je zbog ozljede na radu ili profesionalne bolesti došlo do smanjenja radne sposobnosti uz preostalu radnu sposobnosti ili do smanjenja radne sposobnosti uz djelomični gubitak radne sposobnosti, odnosno otkazu radniku osobi s invaliditetom, </p>
    <p>4) otkazu radniku s navršenih šezdeset godina odnosno starijem od šezdeset godina,</p>
    <p>5) otkazu predstavniku radnika u organu poslodavca. </p>
    <p>Ukoliko se otkaz daje navedenim osobama, u tom smislu je potrebno prethodno ishoditi suglasnost radničkog vijeća/sindikalnog povjerenika.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong> - Nedopušteni razlozi za otkaz ugovora o radu</strong></p>
    <p>Pojašnjenje: ako sud utvrdi da otkaz poslodavca nije dopušten i da radni odnos nije prestao, naložiti će vraćanje radnika na posao, a radnik će imati i pravo na naknadu plaće umanjenu za iznos plaće koju je kroz to vrijeme primao. Radnik koji osporava dopuštenost otkaza može tražiti da sud privremeno, do okončanja spora, naloži njegov povratak na posao. </p>
    <p><strong> - Tumačenje da otkaz ne može biti uručen za vrijeme trudnoće, korištenja rodiljnog, roditeljskog, posvojiteljskog dopusta, rada s polovicom punog radnog vremena, rada s polovicom punog radnog vremena radi pojačane brige i njege djeteta, dopusta trudnice ili majke koja doji dijete, te dopusta ili rada s polovicom punog radnog vremena radi brige i njege djeteta s težim smetnjama u razvoju, odnosno u roku od petnaest dana od prestanka trudnoće ili prestanka korištenja tih prava, poslodavac ne smije otkazati ugovor o radu trudnici i osobi koja se koristi nekim od tih prava. </strong></p>
    <p>Pojašnjenje: otkaz može biti uručen, no otkazni rokovi počinju teći tek po isteku spomenutih okolnosti pa time radni odnos ne može niti prestati sve dok traju spomenute okolnosti.</p>
    <p><strong> - Dostava otkaza nije izvršena u skladu sa Zakonom</strong></p>
    <p>Pojašnjenje: u slučaju dostave koja nije obavljena zakonito, smatra se da otkaz nije niti uručen, a time ne mogu niti nastupiti posljedice otkaza. </p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu. </p>
  `,

  sides: [
    {
      prefix: "Na temelju Zakona o radu,",
      signature: "Za Poslodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: "donosi sljedeću",
  title: "ODLUKU O IZVANREDNOM OTKAZU UGOVORA O RADU",

  noArticleNumbers: true,

  articles: [
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          editable: false,
          parts: [
            { type: 'text', content: 'Radniku' },
            { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
            { type: "text", content: "," },
            { type: 'text', content: 'iz',},
            { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
            { type: 'text', content: ',' },
            { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
            { type: "text", content: "," },
            { type: 'text', content: 'OIB:' },
            { type: "input",  required: true,},
            { type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
            { type: 'text', content: 'otkazuje se ugovor o radu na' },
            { type: "input",  required: true, placeholder: "određeno/neodređeno"},
            { type: 'text', content: 'vrijeme, sklopljen dana'},
            { type: 'input', value: '', required: true },
            { type: 'text', content: 'godine,' },
            { type: "text", content: "jer je učinio osobito tešku povredu iz radnog odnosa zbog čega nastavak radnog odnosa između Poslodavca i radnika nije moguć." },
          ]
        }]
    },
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Ugovor o radu se otkazuje bez otkaznog roka te radni odnos Radnika prestaje danom dostave ove Odluke radniku."
        }]
    },
    {
      title: "",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Zbog činjenica navedenih u ovoj Odluci koje predstavljaju opravdani razlog ovog Otkaza, Poslodavac zadržava pravo da od Radnika - krivca za otkaz,  traži naknadu štete zbog neizvršenja ugovorom o radu preuzetih obveza.",
        },
      ]
    },
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Sva prava iz rada i po osnovi rada kod Poslodavca, Radnik ostvaruje do prestanka radnog odnosa na način određen ovom Odlukom."
        }]
    },
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Za svaki otkaz potrebno je posebno je obrazložiti točno određenu tešku povredu radne obveze koja može biti različita s obzirom na specifičnost djelatnosti i organizacije posla poslodavca.",
          content: "OBRAZLOŽENJE U NASTAVKU JE DANO SAMO RADI PRIMJERA, NO BUDUĆI JE OBRAZLOŽENJE NAJBITNIJI DIO ODLUKE O OTKAZU, PRIJE IZRADE OBRAZLOŽENJA OBAVEZNO PROČITAJTE UVODNI TEKST GORE VEZAN UZ OBRAZLOŽENJE.\r\nU SVAKOM SLUČAJU, RAZLOZI OTKAZA MORAJU BITI JASNI I NEDVOSMISLENI TE USKLAĐENI S OBZIROM NA VRSTU OTKAZA KOJA SE DAJE RADNIKU. TAKOĐER, RAZLOZI OTKAZA NAVEDENI U OBRAZLOŽENJU SE U SLUČAJU SUDSKOG SPORA NE MOGU PROŠIRIVATI NOVIM DOKAZIMA I RAZLOZIMA.\r\nPrimjer obrazloženja:\r\nRadnik je učinio osobito tešku povredu iz radnog odnosa, a koja se sastoji u tome što dana ______ godine nije došao na radno mjesto te se od navedenog datuma do dana ove Odluke o otkazu nije pojavio na radnom mjestu, a nedolaske nije opravdao."
        }]
    },
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: true,
          help: "Pretpostavka zakonske osnovanosti otkaza.",
          choices: [
            "Poslodavac je pozivom omogućio Radniku pravo na obranu, a na koji poziv se Radnik nije odazvao.",
            "Poslodavac nije u mogućnosti Radniku pružiti pravo na obranu jer iz njegovih postupaka proizlazi da nije zainteresiran za nastavak rada kod Poslodavca te Poslodavac opravdano očekuje da se Radnik ne bio odazvao pozivu za iznošenje obrane.",
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        },
      ]
    },
    {
      title: "",
      mandatory: false,
      dummy: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Poslodavac je dana " },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine priopćio radničkom vijeću namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se radničko vijeće pozitivno očitovalo dana " },
                { type: "input", value: "", required: true, help: "Prije odluke o otkazu, poslodavac se dužan savjetovati s radničkim vijećem, ukoliko isto postoji kod poslodavca. Radničko vijeće je dužno u roku od osam dana, a u slučaju izvanrednog otkaza u roku od pet dana, dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Poslodavac je dana " },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se sindikalni povjerenik očitovao pozitivno dana " },
                { type: "input", value: "", required: true, help: "Ako kod poslodavca nije utemeljeno radničko vijeće, a kod Poslodavca djeluje sindikalni povjerenik, isti preuzima sva prava i obveze radničkog vijeća te je u tom smislu dužan ju roku od osam dana, a u slučaju izvanrednog otkaza u roku od pet dana, dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu. U tom smislu, Poslodavac je dužan prije otkaza, prethodno se savjetovati sa sindikalnim povjerenikom." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Poslodavac je dana " },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine priopćio radničkom vijeću namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se radničko vijeće nije očitovalo u roku određenom Zakonom o radu (8 dana) čime se smatra da nema primjedbi i prijedloga." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Poslodavac je dana " },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se sindikalni povjerenik nije očitovao u roku određenom Zakonom o radu (8 dana) čime se smatra da nema primjedbi i prijedloga." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Poslodavac je dana " },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine priopćio radničkom vijeću namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se radničko vijeće očitovalo negativno, no Poslodavac ipak donosi ovu Odluku." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Poslodavac je dana " },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se sindikalni povjerenik očitovao negativno, no Poslodavac ipak donosi ovu Odluku." },
              ]
            }],
        },
      ]
    },
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Slijedom toga, a sukladno Zakonu o radu odlučeno je kako je navedeno u ovoj Odluci.\r\nRadnik nema pravo na poštivanje propisanog otkaznog roka, na temelju članka 116. st.1. Zakona o radu.\r\nRadnik nema pravo na otpremninu, na temelju članka 126. st. 1. Zakona o radu.\r\nSlijedom iznesenog, donesena je ova Odluka."
        }]
    },
    {
      title: "NAPUTAK O ZAŠTITI PRAVA",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Protiv ove Odluke Radnik može Poslodavcu podnijeti zahtjev radi zaštite svojih prava, u roku od 15 dana od dana dostave ove Odluke."
        }]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
    {
      static: true,
      mandatory: true,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
          content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
        },
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/16_otkaz_ugovora_o_radu_izvanredni.ts